




















































import { Component, Mixins, Inject } from "vue-property-decorator";
import { IUser } from "@/models/users";
import RequestPromises from "@/mixins/requestPromises";
import {
  ITicketProvider,
  ITicketProviderMethods
} from "@/models/providers/ticket";

@Component({
  components: {
    "user-search-table": () =>
      import("@/components/app/global/user/userSearchTable.vue"),
    "assigned-users-table": () =>
      import("@/components/app/global/tickets/ticketAssigneesTable.vue")
  }
})
export default class ManageAssigneesModal extends Mixins(RequestPromises) {
  // Injected
  @Inject({ from: "ticketProviderMethods" })
  public readonly $ticketMethods!: ITicketProviderMethods;
  @Inject({ from: "ticketProvider" })
  public readonly $ticketData!: () => ITicketProvider;

  // Data
  public assignees: IUser[] = [];
  public leadAgentId: IUser["id"] | null = this.$_.get(
    this.$ticket.leadAgent,
    "id",
    null
  );
  public isProcessing = false;

  // Lifecycle Methods
  public created() {
    this.assignees = this.$_.clone(this.$ticket.ticket.users);
  }

  // Computed
  public get $ticket() {
    return this.$ticketData();
  }
  public get userIds() {
    return this.$_.map(this.assignees, "id");
  }
  public get canSubmit() {
    // Check assignees have changed
    return (
      !this.$_.isEqual(
        this.$_.map(this.$ticket.ticket.users, "id"),
        this.userIds
      ) || this.$_.get(this.$ticket.leadAgent, "id", null) !== this.leadAgentId
    );
  }

  public get mappedAssignees() {
    const _ = this.$_;
    return _.orderBy(
      _.map(this.assignees, (user: IUser) => {
        return {
          ..._.pick(user, ["id", "fullname", "email"]),
          image: _.get(user, "image.full_url"),
          default: user.id === this.leadAgentId
        };
      }),
      ["fullname"],
      ["asc"]
    );
  }

  // Methods
  public selectUser(user: IUser) {
    if (this.$_.isEmpty(user)) return;
    if (!this.assignees.length) this.leadAgentId = user.id;
    this.assignees = this.$_.unionBy(this.assignees, [user], "id");
  }

  public removeUser(user: IUser) {
    this.assignees = this.$_.remove(this.assignees, u => u.id !== user.id);
    if (user.id === this.leadAgentId) this.leadAgentId = null;
  }

  public makeLeadAgent(userId: IUser["id"]) {
    this.leadAgentId = this.leadAgentId === userId ? null : userId;
  }

  public assignUsers() {
    if (this.isProcessing) return;
    this.isProcessing = true;
    this.$ticketMethods
      .assignUsers(
        this.$_.map(this.userIds, id => ({
          id,
          default: this.leadAgentId === id ? true : false
        }))
      )
      .then(() => this.$emit("close"))
      .finally(() => {
        this.isProcessing = false;
      });
  }
}
